import React from 'react'
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody, useDisclosure, Box } from '@chakra-ui/react';
import { DataContext } from '../../../../../state/DataContext/DataContext';
import EditJob from './EditJob';

export default function EditJobBtn(props: any) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { data, actions } = React.useContext(DataContext);
    return (

        <>
            <Box cursor="pointer" ref={props.editJobBtn} fontSize="1em" fontWeight="normal"
                onClick={(e) => {
                    onOpen()
                }}>
                {props.renderBtn()}
            </Box>

            <Modal size="xl" isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody>
                        <EditJob Job={props.job} afterEditFn={() => {
                            onClose()
                            if (props.afterEditFn) props.afterEditFn();
                        }} />
                    </ModalBody>
                </ModalContent>
            </Modal>

        </>

    )
}
